/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.12",
  "buildId": "20260730-1749-66bcaa4",
  "builtAt": "2026-07-30T12:19:46.297Z"
});
